import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { ensureSession } from '@/lib/session'
import { ensureWorkspaces } from '@/lib/workspace'

/**
 * The gate for everything planners see. Guest RSVP routes live under _public
 * and deliberately never pass through here.
 */
export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    const session = await ensureSession(context.queryClient)

    if (!session) {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }

    // Onboarding is the only way to get a first workspace, so it has to stay
    // reachable without one — otherwise the redirect chases its own tail.
    if (!location.pathname.startsWith('/onboarding')) {
      const workspaces = await ensureWorkspaces(context.queryClient)

      if (workspaces.length === 0) {
        throw redirect({ to: '/onboarding' })
      }
    }

    return { session }
  },
  component: () => <Outlet />,
})
